// extracted by mini-css-extract-plugin
module.exports = {"PurchaseCloseModalAlert":"PurchaseCloseModalAlert_PurchaseCloseModalAlert__25709","PurchaseCloseModalAlert__Text":"PurchaseCloseModalAlert_PurchaseCloseModalAlert__Text__2_YQJ"};